var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-tree"},[_c('div',{staticClass:"tree-content"},_vm._l((_vm.accounts),function(account){return _c('TreeNode',{key:account.id,attrs:{"account":account,"onAdd":_vm.onAdd,"onEdit":_vm.onEdit,"onDelete":_vm.onDelete}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }